package com.eladfinish.bible.contest.utils

/**
 * Developed by
 * @author Elad Finish
 */

fun verbalGrade(grade: Int): String {
    val str: String =
        when (grade) {
            100 -> "מצוין"
            in 95..99 -> "מעולה"
            in 90..94 -> "טוב מאוד"
            in 80..89 -> "כמעט טוב מאוד"
            in 70..79 -> "טוב"
            in 60..69 -> "כמעט טוב"
            in 50..59 -> "מספיק"
            else -> "טעון שיפור"
        }
    return "הערכה: $str"
}